import { createContext } from "react";
import CreditCheckResult from "./models/CreditCheckResult";
import { Agreement } from "./models/Agreement";
import { AppConfig } from "./config";
import Bundle from "./models/Bundle";
import { AgreementMetadata } from "./models/AgreementMetadata";
import Product from "./models/Product";

export type SalesContextState = {
  orderIds: string[];
  userToken?: string;
  products: Product[];
  /**
   * Signed or unsigned.
   */
  agreement?: Agreement;
  agreementMeta?: AgreementMetadata;
  /**
   * Currently revised agreement.
   */
  creditCheckResult: CreditCheckResult;
  config: AppConfig;
  bundles: Bundle[];
  monthlyPaymentTotal: number;
  qcRecording?: Blob;
  offerSignatureUri?: string;
  offerUri: string;
  isDemo: boolean;
};

/**
 * Global app context.
 */
export const SalesContext = createContext<SalesContextState & {
  setProducts: (products: Product[]) => void;
  setOrderIds: (orderIds: string[]) => void;
  setUserToken: (userToken: string) => void;
  setAgreement: (agreement: Agreement) => void;
  setAgreementMeta: (agreementMeta: AgreementMetadata) => void;
  setCreditCheckResult: (creditCheck: CreditCheckResult) => void;
  setConfig: (config: AppConfig) => void;
  setMonthlyPaymentTotal: (total: number) => void;
  setBundles: (bundles: Bundle[]) => void;
  setQcRecording: (recording: Blob) => void;
  setOfferSignatureUri: (uri: string) => void;
  setOfferUri: (uri: string) => void;
  setDemo: (isDemo: boolean) => void;
}>(null);